/**
 * Bring Your Own Professional (migratie 164).
 *
 * Employer Cockpit: /api/employer/byop
 * Publiek (uitnodigingslink) en professional: /api/byop
 * Registratie: POST /api/auth/register met `byop_token`
 */
import api from './api';

const d = <T,>(r: { data: { data: T } }) => r.data.data;

export type ByopStatus = 'PENDING_REGISTRATION' | 'REGISTERED' | 'REVOKED' | 'EXPIRED';

export interface ByopUitnodiging {
  id: string;
  email: string;
  first_name: string | null;
  last_name: string | null;
  status: ByopStatus;
  expires_at: string;
  registered_at: string | null;
  created_at: string;
  professional_id: string | null;
  screening_status: string | null;
  byop_start_date: string | null;
  huidige_fee_percentage: number | null;
  huidige_maand: number | null;
}

export interface ByopUitnodigingInfo {
  email: string;
  first_name: string | null;
  last_name: string | null;
  company_name: string;
  expires_at: string;
}

export type ByopProfessionalStatus =
  | { gekoppeld: false }
  | {
      gekoppeld: true;
      bedrijfsnaam: string;
      legal_akkoord: boolean;
      legal_akkoord_at: string | null;
      legal_versie: string;
      legal_teksten: { vrijwaring_concurrentiebeding: string; aansprakelijkheid_rechtstreeks: string };
      byop_start_date: string | null;
    };

export const byopApi = {
  overzicht: () => api.get('/employer/byop').then(d<ByopUitnodiging[]>),
  nodigUit: (invoer: { email: string; first_name?: string; last_name?: string }) =>
    api.post('/employer/byop', invoer).then(d<ByopUitnodiging>),
  trekIn: (id: string) => api.delete(`/employer/byop/${id}`),

  uitnodiging: (token: string) => api.get(`/byop/invite/${token}`).then(d<ByopUitnodigingInfo>),
  status: () => api.get('/byop/status').then(d<ByopProfessionalStatus>),
};
